import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import * as moment from 'moment';
import {debounceTime, Observable, Subject, switchMap} from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import {UserService} from '../../../../../../auth/service';

export interface IGenerateActivityFormData {
    user_id: number | null;
    description: string;
    due_date: string | null;
}

@Component({
    selector: 'app-ai-generate-activity',
    templateUrl: './ai-generate-activity.component.html',
    styleUrls: ['./ai-generate-activity.component.scss'],
    standalone: false
})
export class AiGenerateActivityComponent implements OnInit, AfterViewInit, OnDestroy {
    private readonly _userSearchChange$: Subject<string> = new Subject<string>();
    private readonly _debounceTime: number = 500;

    identityRevealedValidator: ValidatorFn = (
        control: AbstractControl,
    ): ValidationErrors | null => {
        const user_id = control.get('user_id');
        const due_date = control.get('due_date');
        const description = control.get('description');
        if (user_id.value != null || due_date.value != null || due_date?.value?.trim().length > 0 || description.value?.trim().length > 0) {
            if (user_id?.value === null) {
                this.todoForm.controls.user_id.setErrors({required: true});
            } else {
                this.todoForm.controls.user_id.setErrors(null);
            }

            if (due_date?.value === null || due_date?.value?.trim().length === 0) {
                this.todoForm.controls.due_date.setErrors({required: true});
            } else {
                this.todoForm.controls.due_date.setErrors(null);
            }

            if (description?.value?.trim().length === 0) {
                this.todoForm.controls.description.setErrors({required: true});
            } else {
                this.todoForm.controls.description.setErrors(null);
            }
        } else {
            this.todoForm?.controls?.due_date?.setErrors(null);
            this.todoForm?.controls?.user_id?.setErrors(null);
            this.todoForm?.controls?.description?.setErrors(null);
        }

        return null;
    };

    public userData$:Observable<{id: number, name:string}[]>;
    @Input() public submitted: boolean = false;

    private untilDestroy$: Subject<void> = new Subject();

    @Output() formDataChanged: EventEmitter<IGenerateActivityFormData> = new EventEmitter();
    @Output() isValid: EventEmitter<boolean> = new EventEmitter();

    constructor(private formBuilder: FormBuilder,
                private userService:UserService
                ) {
    }

    ngOnDestroy(): void {
        this.untilDestroy$.next();
        this.untilDestroy$.complete();
    }

    ngOnInit(): void {

     this.userData$ = this._userSearchChange$
            .pipe(
                takeUntil(this.untilDestroy$),
                debounceTime(this._debounceTime),
                switchMap(searchValue => this.userService.usersAutocomplete(false,searchValue)),
                map(x=> x.data.map(y=> ({
                    id: y.id,
                    name: y.name
                })))
            )

        this.todoForm.valueChanges
            .pipe(takeUntil(this.untilDestroy$))
            .subscribe(formValue => {
                this.formDataChanged.next(formValue);
            });

        this.todoForm.statusChanges
            .pipe(takeUntil(this.untilDestroy$))
            .subscribe(status => {
                this.isValid.next(status === "VALID");
            });
    }

    ngAfterViewInit(): void {
        this._userSearchChange$.next('');
    }

    public todoForm: FormGroup = this.formBuilder.group({
        description: [''],
        due_date: [null],
        user_id: [null],
    }, {validators: this.identityRevealedValidator});




    /**
     * Get due date on change and patching to formcontrol
     * @param $event
     */
    dueDate($event) {
        this.todoForm.patchValue({due_date: moment($event.target?.value).format()});
    }

    submitTodo() {
        this.submitted = true;
    }


    filterUser(value: string) {
        this._userSearchChange$.next(value);
    }
}
